import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate, useLocation, Navigate } from 'react-router-dom';
import Practice from './pages/Practice';
import Exam from './pages/Exam';
import Dashboard from './pages/Dashboard';
import QuestionPage from './pages/QuestionPage';
import { ThemeProvider, CssBaseline, createTheme } from '@mui/material';
import { FaTimes, FaInstagram, FaTelegramPlane } from 'react-icons/fa';
import Register from './pages/Register';
import { Drawer, IconButton, List, ListItem, ListItemText, Box, ListItemIcon } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import useMediaQuery from '@mui/material/useMediaQuery';
import HomeIcon from '@mui/icons-material/Home';
import LoginIcon from '@mui/icons-material/Login';
import StarIcon from '@mui/icons-material/Star';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SchoolIcon from '@mui/icons-material/School';
import AssignmentIcon from '@mui/icons-material/Assignment';
import LogoutIcon from '@mui/icons-material/Logout';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Browser } from '@capacitor/browser';
import { App as CapacitorApp } from '@capacitor/app';
import DailyQuestion from './components/DailyQuestion';

function Home() {
  const isMobile = window.innerWidth <= 768;
  
  return (
    <>
      <style>
        {`
          @keyframes gradientShift {
            0%, 100% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
          }
          
          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
          }
          
          @keyframes pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.05); }
          }
          
          @keyframes slideInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          

        `}
      </style>
      
      {/* Hero Section with Full-Screen Gradient Background */}
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
        backgroundSize: '400% 400%',
        animation: 'gradientShift 15s ease infinite',
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: isMobile ? '20px' : '40px'
      }}>
        {/* Animated Background Elements */}
        <div style={{
          position: 'absolute',
          top: '10%',
          left: '10%',
          width: '100px',
          height: '100px',
          background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
          borderRadius: '50%',
          animation: 'float 6s ease-in-out infinite',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255,255,255,0.2)'
        }}></div>
        
        <div style={{
          position: 'absolute',
          bottom: '20%',
          right: '15%',
          width: '150px',
          height: '150px',
          background: 'linear-gradient(135deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.03) 100%)',
          borderRadius: '50%',
          animation: 'float 8s ease-in-out infinite reverse',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255,255,255,0.15)'
        }}></div>
        
        <div style={{
          position: 'absolute',
          top: '60%',
          left: '20%',
          width: '80px',
          height: '80px',
          background: 'linear-gradient(135deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.02) 100%)',
          borderRadius: '50%',
          animation: 'pulse 4s ease-in-out infinite',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255,255,255,0.1)'
        }}></div>
        
        {/* Main Content Container */}
        <div style={{
          display: 'flex', 
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'center', 
          justifyContent: 'center', 
          maxWidth: '1200px',
          width: '100%',
          gap: isMobile ? 0 : 60,
          zIndex: 10
        }}>
          {/* Illustration with Enhanced Styling - Hidden on Mobile */}
          {!isMobile && (
            <div style={{
              flex: 1,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              maxWidth: '50%',
              animation: 'slideInUp 1s ease-out'
            }}>
              <div style={{
                background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.85) 100%)',
                borderRadius: 24,
                padding: 32,
                boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255,255,255,0.3)',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: '4px',
                  background: 'linear-gradient(90deg, #667eea, #764ba2, #f093fb, #667eea)',
                  backgroundSize: '200% 100%',
                  animation: 'gradientShift 3s ease infinite'
                }}></div>
                
                <img 
                  src="/c.svg" 
                  alt="ياعيل ماستر"
                  style={{
                    width: '100%',
                    maxWidth: 380,
                    height: 'auto',
                    objectFit: 'contain',
                    filter: 'drop-shadow(0 8px 24px rgba(0,0,0,0.1))'
                  }}
                />
              </div>
            </div>
          )}
          
          {/* Enhanced Text Content */}
          <div style={{
            flex: isMobile ? 'none' : 1,
            textAlign: 'center',
            maxWidth: isMobile ? '100%' : '50%',
            width: isMobile ? '100%' : 'auto',
            animation: 'slideInUp 1s ease-out 0.2s both'
          }}>
            <div style={{
              background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.85) 100%)',
              borderRadius: 24,
              padding: isMobile ? 24 : 40,
              boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(255,255,255,0.3)',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '4px',
                background: 'linear-gradient(90deg, #667eea, #764ba2, #f093fb, #667eea)',
                backgroundSize: '200% 100%',
                animation: 'gradientShift 3s ease infinite'
              }}></div>
              
              <h1 style={{ 
                fontSize: isMobile ? 32 : 48, 
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                marginBottom: 20, 
                direction: 'rtl',
                fontWeight: 'bold',
                textShadow: '0 2px 4px rgba(0,0,0,0.1)',
                lineHeight: 1.2
              }}>
               ياعيل ماستر بيسهّلها عليك <span style={{ 
                 textShadow: 'none',
                 WebkitBackgroundClip: 'initial',
                 WebkitTextFillColor: 'initial',
                 backgroundClip: 'initial',
                 color: '#667eea',
                 display: 'inline-block',
                 verticalAlign: 'middle'
               }}>😉</span>
              </h1>
              
              <p style={{ 
                fontSize: isMobile ? 18 : 22, 
                color: '#4a5568', 
                maxWidth: 500, 
                textAlign: 'center', 
                marginBottom: 32, 
                direction: 'rtl',
                margin: '0 auto 32px auto',
                lineHeight: 1.6,
                fontWeight: '500'
              }}>
                بدل ما تضيع وقتك، تدرب معنا على كل شيء تحتاجه للياعيل — تمارين، محاكاة، متابعة تقدّم...
                <br />
                جاهز تبلّش؟ 👇
              </p>
              
              {/* Enhanced CTA Button */}
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <Link to="/login" style={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: '#fff',
                  padding: isMobile ? '16px 36px' : '18px 48px',
                  borderRadius: 16,
                  fontSize: isMobile ? 18 : 20,
                  textDecoration: 'none',
                  fontWeight: 'bold',
                  boxShadow: '0 8px 32px rgba(102, 126, 234, 0.4)',
                  transition: 'all 0.3s ease',
                  direction: 'rtl',
                  display: 'inline-block',
                  position: 'relative',
                  overflow: 'hidden',
                  border: '2px solid transparent'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 12px 40px rgba(102, 126, 234, 0.6)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 8px 32px rgba(102, 126, 234, 0.4)';
                }}>
                  <span style={{ position: 'relative', zIndex: 2 }}>
                    🚀 ابدأ الآن
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function LogoutButton() {
  const handleLogout = () => {
    window.location.href = process.env.REACT_APP_API_URL + '/auth/logout';
  };
  return (
    <button
      onClick={handleLogout}
      style={{
        margin: '0 12px',
        fontWeight: 500,
        color: '#fff',
        background: '#ef4444',
        border: 'none',
        borderRadius: 6,
        padding: '8px 18px',
        cursor: 'pointer',
        fontSize: 16,
      }}
    >
      تسجيل الخروج
    </button>
  );
}

function Login() {
  const [emailOptIn, setEmailOptIn] = React.useState(true);
  const [isLoading, setIsLoading] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const getGoogleAuthUrl = () => {
    const baseUrl = process.env.REACT_APP_API_URL + '/auth/google';
    const params = new URLSearchParams();
    if (emailOptIn) {
      params.append('emailOptIn', '1');
    }
    // Get returnTo from query params
    const searchParams = new URLSearchParams(location.search);
    const returnTo = searchParams.get('returnTo');
    const ref = searchParams.get('ref');
    if (returnTo) {
      params.append('returnTo', returnTo);
    }
    if (ref) {
      params.append('ref', ref);
    }
    return params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
  };

  const handleGoogleLogin = async () => {
    setIsLoading(true);
    try {
      // Check if we're running in Capacitor (mobile app)
      if (window.Capacitor) {
        // Use Capacitor Browser for OAuth
        const authUrl = getGoogleAuthUrl();
        const result = await Browser.open({ 
          url: authUrl,
          windowName: '_self'
        });
        
        // The OAuth callback will redirect back to the app
        // We'll handle the redirect in the main App component
        console.log('OAuth completed:', result);
      } else {
        // Fallback for web browser
        window.location.href = getGoogleAuthUrl();
      }
    } catch (error) {
      console.error('OAuth error:', error);
      alert('حدث خطأ في تسجيل الدخول. يرجى المحاولة مرة أخرى.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <style>
        {`
          @keyframes gradientShift {
            0%, 100% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
          }
          
          @keyframes slideInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
      
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
        backgroundSize: '400% 400%',
        animation: 'gradientShift 15s ease infinite',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}>
        <div style={{
          background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.85) 100%)',
          borderRadius: 24,
          padding: '48px 40px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(255,255,255,0.3)',
          position: 'relative',
          overflow: 'hidden',
          maxWidth: '400px',
          width: '100%',
          textAlign: 'center',
          animation: 'slideInUp 1s ease-out'
        }}>
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '4px',
            background: 'linear-gradient(90deg, #667eea, #764ba2, #f093fb, #667eea)',
            backgroundSize: '200% 100%',
            animation: 'gradientShift 3s ease infinite'
          }}></div>
          
          <h2 style={{
            fontSize: 32,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            marginBottom: 24,
            direction: 'rtl',
            fontWeight: 'bold'
          }}>
            تسجيل الدخول
          </h2>
          
          <p style={{
            fontSize: 16,
            color: '#4a5568',
            marginBottom: 32,
            direction: 'rtl',
            lineHeight: 1.6
          }}>
            سجل دخولك للوصول إلى منصة ياعيل ماستر
          </p>
          
          <button
            onClick={handleGoogleLogin}
            disabled={isLoading}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: isLoading ? '#ccc' : 'linear-gradient(135deg, #4285F4 0%, #34A853 100%)',
              color: '#fff',
              padding: '16px 32px',
              borderRadius: 16,
              fontSize: 18,
              textDecoration: 'none',
              fontWeight: 'bold',
              gap: '12px',
              transition: 'all 0.3s ease',
              boxShadow: '0 8px 32px rgba(66, 133, 244, 0.3)',
              width: '100%',
              position: 'relative',
              overflow: 'hidden',
              border: 'none',
              cursor: isLoading ? 'not-allowed' : 'pointer'
            }}
            onMouseEnter={(e) => {
              if (!isLoading) {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 12px 40px rgba(66, 133, 244, 0.4)';
              }
            }}
            onMouseLeave={(e) => {
              if (!isLoading) {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 8px 32px rgba(66, 133, 244, 0.3)';
              }
            }}
          >
            {/* Google Icon */}
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path fill="#fff" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#fff" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#fff" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#fff" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            {isLoading ? 'جاري تسجيل الدخول...' : 'تسجيل الدخول باستخدام جوجل'}
          </button>
          
          {/* Email Opt-in Checkbox */}
          <div style={{
            marginTop: 20,
            padding: '16px',
            background: 'linear-gradient(135deg, rgba(34, 197, 94, 0.08) 0%, rgba(16, 185, 129, 0.08) 100%)',
            borderRadius: 12,
            border: '1px solid rgba(34, 197, 94, 0.2)',
            textAlign: 'right',
            direction: 'rtl'
          }}>
            <label style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '12px',
              cursor: 'pointer',
              fontSize: 15,
              color: '#1f2937',
              lineHeight: 1.6
            }}>
              <input
                type="checkbox"
                checked={emailOptIn}
                onChange={(e) => setEmailOptIn(e.target.checked)}
                style={{
                  width: 20,
                  height: 20,
                  marginTop: 2,
                  cursor: 'pointer',
                  accentColor: '#22c55e',
                  flexShrink: 0
                }}
              />
              <span>
                <span style={{ fontWeight: 'bold', color: '#059669' }}>📧 نعم، أريد الحصول على أقوى المواد التحضيرية!</span>
                <br />
                <span style={{ fontSize: 14, color: '#4b5563' }}>
                  اشترك لتلقي الأسئلة الساخنة، ملخصات حصرية، ونصائح ذهبية تساعدك على التفوق في امتحان ياعيل مباشرة إلى بريدك الإلكتروني. لا تفوّت الفرصة!
                </span>
              </span>
            </label>
          </div>

          <div style={{
            marginTop: 16,
            padding: '16px',
            background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
            borderRadius: 12,
            border: '1px solid rgba(102, 126, 234, 0.2)'
          }}>
            <p style={{
              fontSize: 14,
              color: '#667eea',
              margin: 0,
              direction: 'rtl'
            }}>
              🔒 تسجيل الدخول آمن ومحمي
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

function RequireAuth({ user, children }) {
  const location = useLocation();
  // Allow public access to home, login, register, and individual question pages
  if (location.pathname === '/' || 
      location.pathname === '/login' || 
      location.pathname === '/register' ||
      location.pathname.startsWith('/practice/question/')) {
    return children;
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function App() {
  const [user, setUser] = useState(null);
  const [showTelegramBanner, setShowTelegramBanner] = useState(false);
  const [showExpiryBanner, setShowExpiryBanner] = useState(true);
  const [showExpiredNotice, setShowExpiredNotice] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const isMobile = useMediaQuery('(max-width:600px)');
  const navigate = useNavigate();
  const location = useLocation();
  
  // Daily Question state
  const [showDailyQuestion, setShowDailyQuestion] = useState(false);
  const [notificationPermission, setNotificationPermission] = useState('default');
  const [showNotificationBanner, setShowNotificationBanner] = useState(false);
  // Add state for mobile user menu
  const [showUserMenu, setShowUserMenu] = useState(false);

  // Telegram banner: initialize from localStorage (dismiss persists)
  useEffect(() => {
    try {
      const hidden = localStorage.getItem('hideTelegramBanner') === '1';
      setShowTelegramBanner(!hidden);
    } catch (e) {
      setShowTelegramBanner(true);
    }
  }, []);

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + '/api/user', {
      credentials: 'include',
    })
      .then(res => res.json())
      .then(data => setUser(data.user));
  }, []);

  // Handle deep links for OAuth callback
  useEffect(() => {
    if (window.Capacitor) {
      const handleAppUrlOpen = (event) => {
        console.log('App URL opened:', event.url);
        if (event.url && event.url.includes('com.yael.exam://auth-success')) {
          console.log('OAuth callback received:', event.url);
          // Parse the returnTo parameter if present
          const urlObj = new URL(event.url);
          const returnTo = urlObj.searchParams.get('returnTo');
          if (returnTo) {
            navigate(returnTo);
          } else {
            navigate('/practice');
          }
        }
      };

      const handleAppStateChange = (state) => {
        if (state.isActive) {
          // Check if we have a deep link URL in the app state as fallback
          const url = state.url;
          if (url && url.includes('com.yael.exam://auth-success')) {
            console.log('OAuth callback received via app state:', url);
            // Parse the returnTo parameter if present
            const urlObj = new URL(url);
            const returnTo = urlObj.searchParams.get('returnTo');
            if (returnTo) {
              navigate(returnTo);
            } else {
              navigate('/practice');
            }
          }
        }
      };

      // Listen for app URL open events (deep links) - primary method
      CapacitorApp.addListener('appUrlOpen', handleAppUrlOpen);
      
      // Also listen for app state changes as fallback
      CapacitorApp.addListener('appStateChange', handleAppStateChange);

      return () => {
        CapacitorApp.removeAllListeners();
      };
    }
  }, [navigate]);

  // Daily Question - Register service worker and check permission
  useEffect(() => {
    const registerServiceWorker = async () => {
      if ('serviceWorker' in navigator) {
        try {
          const registration = await navigator.serviceWorker.register('/service-worker.js');
          console.log('Service Worker registered:', registration);
        } catch (error) {
          console.error('Service Worker registration failed:', error);
        }
      }
    };

    // Check notification permission
    if ('Notification' in window) {
      setNotificationPermission(Notification.permission);
    }

    registerServiceWorker();
  }, []);

  // Daily Question - Show once per day
  useEffect(() => {
    const hasSeenToday = () => {
      const lastSeen = localStorage.getItem('dailyQuestionLastSeen');
      const today = new Date().toDateString();
      console.log('📅 Daily Question Check - Last Seen:', lastSeen, 'Today:', today);
      return lastSeen === today;
    };

    const checkDailyQuestion = () => {
      console.log('🔍 Daily Question - User:', user ? 'Logged in' : 'Not logged in');
      console.log('🔍 Daily Question - Has seen today:', hasSeenToday());
      
      if (user && !hasSeenToday()) {
        console.log('✅ Daily Question - Will show in 2 seconds');
        // Show after 2 seconds of page load
        const timer = setTimeout(() => {
          console.log('📚 Daily Question - Showing now!');
          setShowDailyQuestion(true);
        }, 2000);
        return timer;
      } else {
        console.log('❌ Daily Question - Not showing. User:', !!user, 'Seen today:', hasSeenToday());
      }
    };

    const timer = checkDailyQuestion();
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [user]);

  // Show notification permission banner
  useEffect(() => {
    const bannerDismissed = localStorage.getItem('notificationBannerDismissed');
    if (user && notificationPermission === 'default' && !bannerDismissed) {
      setShowNotificationBanner(true);
    }
  }, [user, notificationPermission]);

  // Subscribe to push notifications
  const subscribeToPushNotifications = async () => {
    try {
      console.log('🔔 Starting push subscription...');

      // Check if service worker is supported
      if (!('serviceWorker' in navigator)) {
        console.error('❌ Service Worker not supported');
        alert('متصفحك لا يدعم التنبيهات. يرجى استخدام متصفح حديث مثل Chrome أو Firefox.');
        return false;
      }

      if (!('PushManager' in window)) {
        console.error('❌ Push messaging not supported');
        alert('متصفحك لا يدعم إشعارات الدفع. يرجى استخدام متصفح حديث.');
        return false;
      }

      // Wait for service worker to be ready
      console.log('⏳ Waiting for service worker...');
      const registration = await navigator.serviceWorker.ready;
      console.log('✅ Service worker ready:', registration);

      // Check if already subscribed
      const existingSubscription = await registration.pushManager.getSubscription();
      if (existingSubscription) {
        console.log('ℹ️ Already subscribed, updating server...');
        // Send existing subscription to server
        const response = await fetch((process.env.REACT_APP_API_URL || '') + '/api/push-subscribe', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          credentials: 'include',
          body: JSON.stringify({
            endpoint: existingSubscription.endpoint,
            keys: {
              p256dh: arrayBufferToBase64(existingSubscription.getKey('p256dh')),
              auth: arrayBufferToBase64(existingSubscription.getKey('auth'))
            }
          })
        });

        if (response.ok) {
          console.log('✅ Existing subscription updated on server');
          return true;
        }
      }

      // Get VAPID public key from server
      console.log('🔑 Fetching VAPID key from:', (process.env.REACT_APP_API_URL || '') + '/api/vapid-public-key');
      const vapidResponse = await fetch((process.env.REACT_APP_API_URL || '') + '/api/vapid-public-key', {
        credentials: 'include'
      });

      if (!vapidResponse.ok) {
        console.error('❌ Failed to fetch VAPID key:', vapidResponse.status);
        alert('فشل الحصول على مفتاح التنبيهات من الخادم.');
        return false;
      }

      const { publicKey } = await vapidResponse.json();
      console.log('✅ VAPID key received:', publicKey.substring(0, 20) + '...');

      // Subscribe to push notifications
      console.log('📱 Subscribing to push manager...');
      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey)
      });
      console.log('✅ Push manager subscription created:', subscription);

      // Send subscription to server
      console.log('📤 Sending subscription to server...');
      const response = await fetch((process.env.REACT_APP_API_URL || '') + '/api/push-subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
          endpoint: subscription.endpoint,
          keys: {
            p256dh: arrayBufferToBase64(subscription.getKey('p256dh')),
            auth: arrayBufferToBase64(subscription.getKey('auth'))
          }
        })
      });

      if (response.ok) {
        console.log('✅ Push subscription saved to server');
        const result = await response.json();
        console.log('Server response:', result);
        return true;
      } else {
        const errorText = await response.text();
        console.error('❌ Server rejected subscription:', response.status, errorText);
        alert('فشل حفظ الاشتراك على الخادم: ' + errorText);
        return false;
      }
    } catch (error) {
      console.error('❌ Error subscribing to push:', error);
      console.error('Error details:', error.message, error.stack);
      alert('حدث خطأ أثناء الاشتراك في التنبيهات: ' + error.message);
    }
    return false;
  };

  // Request notification permission
  const requestNotificationPermission = async () => {
    if ('Notification' in window) {
      console.log('📋 Requesting notification permission...');
      const permission = await Notification.requestPermission();
      console.log('✅ Permission result:', permission);

      setNotificationPermission(permission);
      setShowNotificationBanner(false);
      localStorage.setItem('notificationBannerDismissed', 'true');

      if (permission === 'granted') {
        console.log('✅ Permission granted, subscribing to push...');
        // Subscribe to push notifications
        const subscribed = await subscribeToPushNotifications();
        if (subscribed) {
          console.log('✅ Successfully subscribed to push notifications');
          alert('تم تفعيل التنبيهات بنجاح! سنرسل لك سؤال اليوم كل يوم الساعة 9 صباحاً.');

          // Check subscription status
          fetch((process.env.REACT_APP_API_URL || '') + '/api/push-subscription-status', {
            credentials: 'include'
          })
            .then(res => res.json())
            .then(data => {
              console.log('📊 Subscription status:', data);
            })
            .catch(err => console.error('Error checking subscription status:', err));
        } else {
          console.error('❌ Failed to subscribe to push notifications');
          alert('تم تفعيل الأذونات، لكن فشل الاشتراك في التنبيهات. يرجى المحاولة مرة أخرى.');
        }
      } else if (permission === 'denied') {
        console.warn('⚠️ Notification permission denied');
        alert('تم رفض أذونات التنبيهات. يرجى تفعيلها من إعدادات المتصفح إذا كنت ترغب في تلقي التنبيهات.');
      } else {
        console.log('ℹ️ Notification permission dismissed');
      }
    }
  };

  // Helper functions for push subscription
  const urlBase64ToUint8Array = (base64String) => {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/');
    
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  };

  const arrayBufferToBase64 = (buffer) => {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  };

  const dismissNotificationBanner = () => {
    setShowNotificationBanner(false);
    localStorage.setItem('notificationBannerDismissed', 'true');
  };

  const closeDailyQuestion = () => {
    setShowDailyQuestion(false);
    const today = new Date().toDateString();
    localStorage.setItem('dailyQuestionLastSeen', today);
  };

  // Redirect to /practice after login
  useEffect(() => {
    if (user && location.pathname === '/login') {
      navigate('/practice', { replace: true });
    }
  }, [user, location, navigate]);

  // Check for premium expiry warning (about to expire)
  // Subscription banners disabled - website is now free
  let showBanner = false;
  let expiryMessage = '';
  let showExpiredBanner = false;
  let expiredMessage = '';

  const theme = createTheme({
    direction: 'rtl',
  });

  const navLinks = [
    { to: '/', label: 'الرئيسية', icon: <HomeIcon /> },
    ...(!user ? [{ to: '/login', label: 'تسجيل الدخول', icon: <LoginIcon /> }] : []),
    // Subscription link removed - website is now free
    // { to: '/register', label: 'اشتراك', icon: <StarIcon /> },
    ...(user && user.role === 'admin' ? [{ to: '/dashboard', label: 'لوحة التحكم', icon: <DashboardIcon /> }] : []),
    { to: '/practice', label: 'تمارين', icon: <SchoolIcon /> },
    { to: '/exam', label: 'امتحان تجريبي', icon: <AssignmentIcon /> },
  ];

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {showTelegramBanner && (
        <div style={{
          background: '#0f172a',
          color: '#ffffff',
          borderBottom: '2px solid #22c55e',
          padding: '14px 12px',
          textAlign: 'center',
          fontWeight: 'bold',
          fontSize: 16,
          position: 'sticky',
          top: 0,
          zIndex: 4000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 12,
          direction: 'rtl'
        }}>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
            <span role="img" aria-label="robot">🤖</span>
            <span>
              جديد: تمرّن كل يوم مع بوت ياعيل على تيليجرام — مجاني 100%.
            </span>
            <span role="img" aria-label="books">📚</span>
          </span>
          <a
            href="https://t.me/yaelmasterbot?start=web_yaelmaster"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => window.gtag?.('event', 'click_bot_banner', { source: 'telegram_top_banner' })}
            style={{
              background: '#22c55e',
              color: '#0b141a',
              borderRadius: 6,
              padding: '6px 12px',
              fontWeight: 'bold',
              textDecoration: 'none',
              fontSize: 14
            }}
          >
            افتح البوت مجانًا
          </a>
          <button
            onClick={() => { try { localStorage.setItem('hideTelegramBanner', '1'); } catch (e) {} setShowTelegramBanner(false); }}
            style={{ background: 'none', border: 'none', color: '#9ca3af', fontSize: 20, marginLeft: 8, cursor: 'pointer' }}
            title="إغلاق"
          >
            <FaTimes />
          </button>
        </div>
      )}
      {showExpiredBanner && (
        <div style={{
          background: '#fef3c7',
          color: '#b91c1c',
          borderBottom: '2px solid #f59e42',
          padding: '18px 0',
          textAlign: 'center',
          fontWeight: 'bold',
          fontSize: 18,
          position: 'sticky',
          top: showTelegramBanner ? 56 : 0,
          zIndex: 3000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 16
        }}>
          <span>{expiredMessage}</span>
          <a href="/register" style={{ background: '#f59e42', color: '#fff', borderRadius: 6, padding: '6px 18px', fontWeight: 'bold', textDecoration: 'none', fontSize: 16 }}>جدد الاشتراك</a>
          <button onClick={() => setShowExpiredNotice(false)} style={{ background: 'none', border: 'none', color: '#b91c1c', fontSize: 22, marginLeft: 12, cursor: 'pointer' }} title="إغلاق"><FaTimes /></button>
        </div>
      )}
      {showBanner && (
        <div style={{
          background: '#fffbe7',
          color: '#b45309',
          borderBottom: '2px solid #f59e42',
          padding: '18px 0',
          textAlign: 'center',
          fontWeight: 'bold',
          fontSize: 18,
          position: 'sticky',
          top: (showTelegramBanner ? 56 : 0) + (showExpiredBanner ? 56 : 0),
          zIndex: 2000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 16
        }}>
          <span>{expiryMessage}</span>
          <a href="/register" style={{ background: '#f59e42', color: '#fff', borderRadius: 6, padding: '6px 18px', fontWeight: 'bold', textDecoration: 'none', fontSize: 16 }}>جدد الاشتراك</a>
          <button onClick={() => setShowExpiryBanner(false)} style={{ background: 'none', border: 'none', color: '#b45309', fontSize: 22, marginLeft: 12, cursor: 'pointer' }} title="إغلاق"><FaTimes /></button>
        </div>
      )}
      <nav style={{
        marginBottom: 20,
        textAlign: 'center',
        background: '#fff',
        padding: 16,
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        direction: 'rtl',
        position: 'relative',
      }}>
        {isMobile ? (
          <>
            <IconButton
              onClick={() => setDrawerOpen(true)}
              sx={{ position: 'absolute', right: 12, top: 12, color: '#6366f1' }}
              aria-label="فتح القائمة"
            >
              <MenuIcon fontSize="large" />
            </IconButton>
            <Drawer
              anchor="right"
              open={drawerOpen}
              onClose={() => setDrawerOpen(false)}
              PaperProps={{ sx: { width: 260, direction: 'rtl' } }}
            >
              <Box sx={{ p: 2 }}>
                <List>
                  {navLinks.map(link => (
                    <ListItem button component={Link} to={link.to} key={link.to} onClick={() => setDrawerOpen(false)}>
                      <ListItemIcon sx={{ minWidth: 32, color: '#6366f1', marginLeft: 2, marginRight: 0 }}>
                        {link.icon}
                      </ListItemIcon>
                      <ListItemText primary={link.label} sx={{ textAlign: 'right' }} />
                    </ListItem>
                  ))}
                  <ListItem 
                    button 
                    component="a" 
                    href="https://t.me/yaelmasterbot?start=web_nav" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    onClick={() => setDrawerOpen(false)}
                  >
                    <ListItemIcon sx={{ minWidth: 32, color: '#229ED9', marginLeft: 2, marginRight: 0 }}>
                      <FaTelegramPlane />
                    </ListItemIcon>
                    <ListItemText primary="بوت تيليجرام" sx={{ textAlign: 'right' }} />
                  </ListItem>
                  <ListItem 
                    button 
                    component="a" 
                    href="https://www.instagram.com/yaelmastercom/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    onClick={() => setDrawerOpen(false)}
                  >
                    <ListItemIcon sx={{ minWidth: 32, color: '#E4405F', marginLeft: 2, marginRight: 0 }}>
                      <FaInstagram />
                    </ListItemIcon>
                    <ListItemText primary="انستغرام" sx={{ textAlign: 'right' }} />
                  </ListItem>
                  {user && (
                    <>
                      <ListItem button onClick={() => setShowUserMenu(v => !v)}>
                        <ListItemIcon sx={{ minWidth: 32, color: '#6366f1', marginLeft: 2, marginRight: 0 }}>
                          <AccountCircle />
                        </ListItemIcon>
                        <ListItemText primary={<span style={{ color: '#333', fontWeight: 600 }}>{user.displayName || (user.emails && user.emails[0].value)}</span>} sx={{ textAlign: 'right' }} />
                      </ListItem>
                      {showUserMenu && (
                        <Box sx={{ pl: 4, pr: 2, pb: 1 }}>
                          <ListItem button onClick={() => { setDrawerOpen(false); setShowUserMenu(false); window.location.href = process.env.REACT_APP_API_URL + '/auth/logout'; }}>
                            <ListItemIcon sx={{ minWidth: 32, color: '#ef4444', marginLeft: 2, marginRight: 0 }}>
                              <LogoutIcon />
                            </ListItemIcon>
                            <ListItemText primary={<span style={{ color: '#ef4444', fontWeight: 'bold' }}>تسجيل الخروج</span>} sx={{ textAlign: 'right' }} />
                          </ListItem>
                        </Box>
                      )}
                    </>
                  )}
                </List>
              </Box>
            </Drawer>
            {/* Remove the Menu dropdown for mobile (keep for desktop only) */}
          </>
        ) : (
          <>
            {navLinks.map(link => (
              <Link to={link.to} key={link.to} style={{ margin: '0 12px', fontWeight: 500, color: '#6366f1', textDecoration: 'none' }}>{link.label}</Link>
            ))}
            <a 
              href="https://t.me/yaelmasterbot?start=web_nav" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ 
                margin: '0 12px', 
                fontWeight: 500, 
                color: '#229ED9', 
                textDecoration: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px'
              }}
            >
              <FaTelegramPlane size={16} />
              تيليجرام
            </a>
            <a 
              href="https://www.instagram.com/yaelmastercom/" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ 
                margin: '0 12px', 
                fontWeight: 500, 
                color: '#E4405F', 
                textDecoration: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px'
              }}
            >
              <FaInstagram size={16} />
              انستغرام
            </a>
            {user && (
              <span style={{ margin: '0 12px', color: '#333', fontWeight: 600, cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}
                onClick={e => setAnchorEl(e.currentTarget)}
              >
                <AccountCircle style={{ marginLeft: 6, fontSize: 26 }} />
                {user.displayName || (user.emails && user.emails[0].value)}
              </span>
            )}
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={() => setAnchorEl(null)}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
              transformOrigin={{ vertical: 'top', horizontal: 'center' }}
              dir="rtl"
            >
              <MenuItem onClick={() => { setAnchorEl(null); window.location.href = process.env.REACT_APP_API_URL + '/auth/logout'; }} style={{ color: '#ef4444', fontWeight: 'bold' }}>
                تسجيل الخروج
              </MenuItem>
            </Menu>
          </>
        )}
      </nav>
      <RequireAuth user={user}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={user && user.role === 'admin' ? <Dashboard /> : <Navigate to="/" replace />} />
          <Route path="/practice" element={<Practice />} />
          <Route path="/practice/question/:id" element={<QuestionPage />} />
          <Route path="/exam" element={<Exam />} />
        </Routes>
      </RequireAuth>
      
      {/* Daily Question Modal */}
      {showDailyQuestion && (
        <DailyQuestion onClose={closeDailyQuestion} isMobile={isMobile} />
      )}
      
      {/* Notification Permission Banner */}
      {showNotificationBanner && (
        <div style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          padding: isMobile ? '14px 16px' : '16px 24px',
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: isMobile ? 12 : 16,
          zIndex: 9997,
          boxShadow: '0 -4px 12px rgba(0,0,0,0.1)',
          direction: 'rtl'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, flex: 1 }}>
            <div style={{ fontSize: 28 }}>🔔</div>
            <div>
              <div style={{ fontSize: isMobile ? 14 : 16, fontWeight: 'bold', marginBottom: 4 }}>
                فعّل التنبيهات للحصول على سؤال يومي!
              </div>
              <div style={{ fontSize: isMobile ? 12 : 14, opacity: 0.9 }}>
                سنرسل لك سؤال جديد كل يوم لمساعدتك في التحضير
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8, width: isMobile ? '100%' : 'auto' }}>
            <button
              onClick={requestNotificationPermission}
              style={{
                flex: isMobile ? 1 : 'auto',
                padding: '10px 20px',
                background: 'white',
                color: '#667eea',
                border: 'none',
                borderRadius: 8,
                fontSize: isMobile ? 13 : 14,
                fontWeight: 'bold',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                transition: 'transform 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
              onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
            >
              تفعيل التنبيهات
            </button>
            <button
              onClick={dismissNotificationBanner}
              style={{
                padding: '10px 20px',
                background: 'rgba(255,255,255,0.2)',
                color: 'white',
                border: '1px solid rgba(255,255,255,0.3)',
                borderRadius: 8,
                fontSize: isMobile ? 13 : 14,
                fontWeight: 'bold',
                cursor: 'pointer',
                whiteSpace: 'nowrap'
              }}
            >
              لاحقاً
            </button>
          </div>
        </div>
      )}
      
      {/* Copyright Footer */}
      <footer style={{
        textAlign: 'center',
        padding: '1rem',
        marginTop: '2rem',
        borderTop: '1px solid #e0e0e0',
        background: '#f8f9fa',
        color: '#666',
        fontSize: '14px',
        direction: 'rtl'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <p style={{ margin: '0 0 0.5rem 0' }}>
            © {new Date().getFullYear()} منصة ياعيل ماستر. جميع الحقوق محفوظة.
          </p>
          <p style={{ margin: 0, fontSize: '12px', color: '#888' }}>
            منصة تحضير امتحان المعرفة باللغة العبرية -יע"ל
          </p>
        </div>
      </footer>
    </ThemeProvider>
  );
}

function AppWithRouter() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default AppWithRouter;
